module.exports = __webpack_public_path__ + "static/media/dentalwhitening.cea03450.jpg";